/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
const ChangeUserRoleCourseDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    /* #__PURE__ */ parsers.object([
        ['roleId', codecNumber, 'role_id'],
        ['userId', codecNumber, 'user_id'],
    ]),
    /* #__PURE__ */ parsers.object([
        ['roleId', codecNumber, 'role_id'],
        ['username', codecString],
        ['tenantId', codecString, 'tenant_id'],
    ]),
]);
export const ChangeUserRoleCourseData = ChangeUserRoleCourseDataParser;
